{
  "common": {
    "skipToContent": "跳至主要内容",
    "footer": {
      "copyright": "PAC Hub © 2024–{{year}}。保留所有权利。",
      "followX": "在 X 上关注我们",
      "followLinkedIn": "在 LinkedIn 上关注我们"
    }
  },
  "marketing": {
    "nav": {
      "home": "首页",
      "features": "功能",
      "about": "关于",
      "howItWorks": "如何运作",
      "guides": "使用指南",
      "faq": "常见问题",
      "contact": "联系我们",
      "menuToggle": "打开导航菜单"
    },
    "languageSwitcher": {
      "label": "语言",
      "en": "English",
      "fr": "Français",
      "zh": "中文 (简体)"
    },
    "meta": {
      "home": {
        "title": "PAC Hub | 一次登录。一个家长社区。",
        "description": "一次登录。一个家长社区。PAC Hub 是面向家长咨询委员会的一体化安全平台。"
      },
      "features": {
        "title": "功能 | PAC Hub",
        "description": "面向家长咨询委员会的一体化平台：日历、志愿者、热午餐等，全部在学校网站上，家长只需一次登录。"
      },
      "howItWorks": {
        "title": "如何运作 | PAC Hub",
        "description": "在 yourschool.pachub.ca 为您的家长咨询委员会快速设置：学校网站、家长注册，以及符合委员会运作方式的角色。"
      },
      "guides": {
        "title": "使用指南 | PAC Hub",
        "description": "简短演示，帮助您登录并使用 PAC Hub。"
      },
      "guide": {
        "title": "{{title}} | PAC Hub",
        "description": "PAC Hub 简短操作演示。{{title}}。"
      },
      "about": {
        "title": "关于 PAC Hub",
        "description": "由委员会为委员会打造。面向家长咨询委员会的加拿大本土软件。"
      },
      "faq": {
        "title": "常见问题 | PAC Hub",
        "description": "关于 PAC Hub 的常见问题，面向家长咨询委员会。"
      },
      "contact": {
        "title": "联系 PAC Hub",
        "description": "联系 PAC Hub，了解试点学校以及为您的家长咨询委员会提供的一体化平台。"
      },
      "privacy": {
        "title": "隐私政策 | PAC Hub",
        "description": "PAC Hub 如何收集、使用和保护通过营销网站提交的信息。"
      },
      "notFound": {
        "title": "页面未找到 | PAC Hub"
      }
    },
    "jsonLd": {
      "organizationDescription": "一次登录。一个家长社区。PAC Hub 是面向家长咨询委员会的一体化安全平台。"
    },
    "notFound": {
      "title": "页面未找到",
      "description": "该页面在 PAC Hub 营销网站上不可用。",
      "returnHome": "返回首页"
    },
    "footer": {
      "privacyPolicy": "隐私政策",
      "about": "关于",
      "guides": "使用指南",
      "faq": "常见问题"
    },
    "hero": {
      "title": "一次登录。\n一个家长社区。",
      "tagline": "面向家长咨询委员会的一体化平台。安全、可靠，专为您的学校社区打造。",
      "primaryCta": "查看包含内容",
      "secondaryCta": "加入试点学校"
    },
    "home": {
      "pillarsTitle": "PAC Hub 为何好用",
      "pillarsDescription": "面向家长咨询委员会的一体化平台。学校社区在一个地方访问所有工具。",
      "pillarAllInOneTitle": "家长一站式",
      "pillarAllInOneDescription": "家长在您学校的 PAC Hub 网站登录一次，无需为委员会使用的每个工具单独注册账号。",
      "pillarOnePlaceTitle": "一个查看入口",
      "pillarOnePlaceDescription": "活动、志愿者报名、热午餐、消息和表单始终在同一学校网站，家长少花时间找链接。",
      "pillarTrustTitle": "安全、可靠、归您所有",
      "pillarTrustDescription": "现代身份验证、学校范围的数据，以及明确的承诺：我们不会将您家长社区的联系信息出售给第三方。",
      "howItWorksTeaserTitle": "如何运作",
      "howItWorksTeaserDescription": "您的委员会获得一所学校网站。家庭注册一次。全年在同一地方运营。",
      "howItWorksTeaserCta": "了解如何运作",
      "steps": {
        "schoolSite": {
          "title": "您的学校获得专属网站",
          "description": "您的委员会位于 yourschool.pachub.ca，委员会名称显示在学校的子域名上。"
        },
        "register": {
          "title": "家庭注册一次",
          "description": "家长使用学校代码注册、验证电子邮件，并将孩子关联到班级。"
        },
        "runYear": {
          "title": "全年在同一地方运营",
          "description": "热午餐、活动、消息、会议等，全年使用同一登录。"
        }
      },
      "includedTitle": "包含内容",
      "includedDescription": "委员会所需的一切，集中在一处。",
      "includedItems": {
        "hotLunch": "热午餐",
        "volunteers": "志愿者",
        "budget": "预算",
        "communications": "通讯",
        "meetings": "会议",
        "fundraising": "筹款"
      },
      "includedLearnMore": "了解更多",
      "trustTitle": "信任为本",
      "pilotCtaTitle": "准备好简化您的委员会工作了吗？",
      "pilotCtaDescription": "我们正在接纳试点学校。告诉我们您委员会的情况，我们会说明 PAC Hub 如何服务您的社区。",
      "pilotCtaButton": "联系我们"
    },
    "featuresPage": {
      "metaTitle": "功能 | PAC Hub",
      "metaDescription": "面向家长咨询委员会的一体化平台：日历、志愿者、热午餐等，全部在学校网站上，家长只需一次登录。",
      "heroTitle": "委员会所需的一切",
      "heroDescription": "一所学校网站。一次家长登录。专为家长咨询委员会打造的工具。",
      "pilotCtaTitle": "准备好简化您的委员会工作了吗？",
      "pilotCtaDescription": "我们正在接纳试点学校。告诉我们您委员会的情况，我们会说明 PAC Hub 如何服务您的社区。",
      "pilotCtaButton": "联系我们"
    },
    "featureDomains": {
      "hotLunch": {
        "title": "热午餐",
        "pitch": "在学校网站上专门打造的午餐订购，包含在您的订阅中。",
        "bullets": [
          "每个孩子同一屏幕订购。多日期购物车，一次结账。",
          "每日截止时间、订购时过敏备注，以及关联班级的家庭档案",
          "协调员的供应商工单、班级分发清单和标签导出",
          "委员会额外支持，在班级名单上不显示慈善标签的餐食资助",
          "在学校网站上安全支付处理。热午餐是中心功能，不是附加项。"
        ]
      },
      "calendar": {
        "title": "日历与活动",
        "pitch": "在学校网站上发布委员会社区日历并安排活动。",
        "bullets": [
          "创建并发布线下、线上和混合委员会活动",
          "可选日历可见性和家长主页仪表板小组件",
          "将委员会资料库中的文档附加到活动",
          "适用于嘉年华、烘焙义卖、宾果和委员会会议，而非学校郊游"
        ]
      },
      "volunteers": {
        "title": "志愿者报名",
        "pitch": "在学校网站上进行时段式志愿者报名，家长无需单独的排程账号。",
        "bullets": [
          "带日期、时间、容量和分组的志愿者时段",
          "委员会管理员的候补名单、覆盖视图和名册",
          "学校子域名上的家长志愿者列表",
          "自有 QR 码和短链接进入报名流程，扫描统计由您掌控"
        ]
      },
      "communications": {
        "title": "通讯",
        "pitch": "在子域名上联系家长，无需借用学校行政处理邮件和通讯。",
        "bullets": [
          "yourschool.pachub.ca 上的自有收件箱，可选发送相同内容的邮件",
          "按角色起草、发布和定向消息。通讯是消息加邮件。",
          "About、政策和联系等常设页面，配合时效性更新",
          "协议表单和许可，无需将家长送往其他表单工具",
          "调查与社区意见。委员会可按需选择短信提醒。"
        ]
      },
      "meetings": {
        "title": "委员会会议",
        "pitch": "专为委员会大会和执行会议设计的一体式视频和混合选项。",
        "bullets": [
          "在学校网站上的委员会会议视频房间，而非公开 Zoom 链接",
          "支持混合模式，需要时可填写线下地点",
          "专为委员会治理流程设计的选举和投票",
          "家长使用与午餐和志愿相同的登录加入"
        ]
      },
      "documents": {
        "title": "委员会文档",
        "pitch": "超越负责人更替的治理资料包和档案。",
        "bullets": [
          "将结构化议程起草为品牌 PDF 资料包，并将定稿附加到会议活动",
          "按学年整理的会议记录和治理档案",
          "家长通过学校网站接收会议文档",
          "定稿资料包与活动绑定，不会散落在各邮箱"
        ]
      },
      "schoolYear": {
        "title": "学年、家庭与成员",
        "pitch": "设置学年、将孩子关联到班级，并按委员会实际运作方式管理角色。",
        "bullets": [
          "启用和归档学年。新学年开始时复制班级。",
          "孩子与家庭档案，含班级选择和过敏或饮食备注",
          "可搜索的成员列表、邀请、角色编辑和热午餐协调员分配",
          "负责人更替时的所有权移交，以及针对家长的学年停用",
          "家长主页：未读消息、时段、开放午餐窗口和待办事项"
        ]
      },
      "fundraising": {
        "title": "筹款与捐赠",
        "pitch": "在委员会网站上跟踪活动和捐赠，而非独立门户。",
        "bullets": [
          "带目标和进度跟踪的筹款活动",
          "在慈善资质允许时的捐赠记录和税收收据",
          "与热午餐分开结账，在学校网站上安全支付处理",
          "财务可更新并与委员会分享的活动进度"
        ]
      },
      "budget": {
        "title": "预算与财务工具",
        "pitch": "为财务和审计人员提供预算与实际对比报告和资金分离。",
        "bullets": [
          "月度与年初至今报告的预算与实际视图",
          "委员会需要时的一般基金和游戏基金独立账本",
          "与委员会中心集成的 AGM 和审计友好导出",
          "BC 许可证规则适用时的持牌游戏清单和账本"
        ]
      },
      "trustPlatform": {
        "title": "信任与平台",
        "pitch": "现代安全和学校范围数据，订阅收入资助平台，不出售社区信息。",
        "bullets": [
          "每所学校独立子域名，家长和执行人员基于角色的访问",
          "现代身份验证和学校范围账号。敏感管理操作的审计日志。",
          "我们不出售社区数据给第三方。委员会订阅资助平台。",
          "为学校社区提供英语、法语和中文"
        ]
      }
    },
    "about": {
      "heroTitle": "由委员会为委员会打造",
      "heroDescription": "家长咨询委员会依赖过多工具，并从本就忙于学校运营的学校办公室占用过多时间。",
      "problemTitle": "问题",
      "problemBody": "BC 小学委员会依赖碎片化工具：热午餐网站、视频会议、表单和调查、电子表格、定制网站和短链接工具。多次登录、负责人更替时连续性薄弱，工作落到本就专注于运营学校的办公室人员身上。",
      "solutionTitle": "我们的做法",
      "solutionBody": "一所学校网站，委员会所需的一切集中在一处。",
      "solutionPrinciples": "无广告。不出售邮件。您的数据安全。",
      "solutionTagline": "一次登录。一个家长社区。",
      "founderTitle": "背后是谁",
      "founderBody": "PAC Hub 由两届委员会主席和软件工程师打造，熟悉财务电子表格、午餐协调员邮箱和临时志愿者召集。加拿大本土设计，面向加拿大学校，为想要一个现代中心而非六个书签的委员会服务。",
      "ctaTitle": "与我们交流",
      "ctaDescription": "我们正在 BC 各地接纳试点学校和设计合作伙伴。",
      "ctaButton": "联系我们"
    },
    "howItWorks": {
      "heroTitle": "委员会快速设置",
      "heroDescription": "PAC Hub 在 yourschool.pachub.ca 为委员会提供统一入口。家庭和执行人员如何开始：",
      "steps": {
        "schoolSite": {
          "title": "委员会获得学校网站",
          "description": "委员会在 pachub.ca 子域名上设置，显示学校名称。执行人员与家长使用同一中心管理设置、角色和账单。"
        },
        "register": {
          "title": "家长使用学校代码注册",
          "description": "家长在 yourschool.pachub.ca 注册、验证邮件并将孩子关联到班级。高级代码让委员会执行人员和站点管理员安全入驻。"
        },
        "runYear": {
          "title": "关联孩子并运营全年",
          "description": "家长添加孩子、选择班级，用一次登录处理午餐、活动、消息和志愿。执行人员在同一网站发布活动、菜单和更新。"
        },
        "roles": {
          "title": "角色贴合委员会实际",
          "description": "家长、委员会执行人员、热午餐协调员和站点管理员各见其所需。委员会控制谁可访问活动、消息和成员列表。"
        }
      },
      "rolesTitle": "谁使用 PAC Hub",
      "roles": {
        "parents": {
          "title": "家长",
          "description": "一次登录完成午餐订购、志愿者报名、消息，以及显示下一步待办的主页仪表板。"
        },
        "executives": {
          "title": "委员会执行人员",
          "description": "发布活动、运营午餐项目、发送通讯、管理成员，并在角色更替时移交所有权。"
        },
        "coordinators": {
          "title": "热午餐协调员",
          "description": "管理供应商、菜单、截止时间和导出，无需成为账单负责人或维护单独的午餐账号。"
        }
      },
      "ctaTitle": "查看全部包含内容",
      "ctaButton": "探索功能",
      "pilotCtaTitle": "加入试点学校",
      "pilotCtaDescription": "告诉我们您委员会的情况，我们会说明 PAC Hub 如何契合您的社区。",
      "pilotCtaButton": "联系我们"
    },
    "guides": {
      "heroTitle": "使用指南",
      "heroDescription": "简短演示，帮助您登录并使用 PAC Hub。",
      "empty": "我们将陆续发布操作演示。",
      "backToGuides": "全部指南",
      "sections": {
        "getting-started": "入门"
      },
      "videos": {
        "sign-in": {
          "description": "如何登录学校站点并打开仪表板。"
        },
        "inbox": {
          "description": "如何打开收件箱、阅读消息，并看到未读标记更新。"
        }
      }
    },
    "faq": {
      "heroTitle": "常见问题",
      "heroDescription": "关于 PAC Hub 的常见问题。",
      "items": {
        "whatIsPacHub": {
          "question": "什么是 PAC Hub？",
          "answer": "PAC Hub 是面向家长咨询委员会的一体化平台。委员会在 yourschool.pachub.ca 获得网站，家长一次登录即可使用热午餐、活动、志愿者报名、消息、会议等。一次登录。一个家长社区。"
        },
        "whoIsItFor": {
          "question": "PAC Hub 适合谁？",
          "answer": "小学和初中家长咨询委员会，尤其在 BC，希望一个现代中心取代午餐、志愿者、通讯和会议的分散工具。家长、执行人员、财务和热午餐协调员各有适合角色的访问权限。"
        },
        "pricing": {
          "question": "定价如何运作？",
          "answer": "简单明了的定价，委员会所需的一切工具集中在一处。联系我们了解试点详情和定价。"
        },
        "pilot": {
          "question": "什么是试点学校？",
          "answer": "试点学校在我们早期推广中与我们合作：真实委员会流程、反馈，以及塑造产品的机会。试点获得入驻支持和与团队的直接沟通。使用联系表单告诉我们您委员会的情况。"
        },
        "hotLunchIncluded": {
          "question": "热午餐是否包含？",
          "answer": "是的。热午餐订购是 PAC Hub 的核心，包含在订阅中，不是附加销售。订单在学校网站上使用安全支付处理。"
        },
        "replaceStack": {
          "question": "PAC Hub 能替代我们现有工具吗？",
          "answer": "PAC Hub 旨在将午餐订购、志愿者报名、通讯、会议链接、表单和委员会网站页面整合到一次登录中。您无需在学校子域名上为这些流程维护多个账号。"
        },
        "dataSelling": {
          "question": "你们会出售家长数据吗？",
          "answer": "不会。我们不出售家长或委员会联系信息给第三方，也不向您的社区投放广告。"
        },
        "languages": {
          "question": "支持哪些语言？",
          "answer": "PAC Hub 为学校社区提供英语、法语和中文（简体）支持。更多语言即将推出。"
        },
        "schoolAdmin": {
          "question": "学校办公室必须运营 PAC Hub 吗？",
          "answer": "不需要。PAC Hub 让委员会拥有自己的通讯、通讯和网站内容。学校工作人员可在需要时拥有适当角色，目标是减少本就专注于运营学校的办公室人员被占用的时间和资源。"
        },
        "ownership": {
          "question": "执行人员更替时怎么办？",
          "answer": "PAC Hub 支持所有权移交、归档学年和超越个人负责人的文档。新执行人员继承运行中的中心，而非分散的登录和丢失的文件。"
        }
      },
      "ctaTitle": "还有问题？",
      "ctaButton": "联系我们"
    },
    "trust": {
      "secure": "安全可靠的登录和学校范围账号",
      "noDataSelling": "您的家长社区数据不会出售给第三方",
      "oneFee": "整个委员会一次订阅。专为家长咨询委员会打造的一体化平台",
      "privacyConsent": "以加拿大隐私立场关照学校社区",
      "pacControl": "委员会控制谁可访问活动、消息和成员列表",
      "languages": "为学校社区提供多语言支持"
    },
    "contact": {
      "title": "联系我们",
      "intro": "有兴趣成为试点学校或想了解更多关于 PAC Hub 的信息？",
      "nameLabel": "姓名",
      "namePlaceholder": "您的姓名",
      "emailLabel": "电子邮件",
      "emailPlaceholder": "您的电子邮件",
      "roleLabel": "我是",
      "rolePlaceholder": "选择您的角色",
      "roles": {
        "parent": "家长",
        "pacExecutive": "委员会执行人员",
        "schoolStaff": "学校工作人员",
        "other": "其他"
      },
      "schoolLabel": "学校名称",
      "schoolPlaceholder": "您的学校（可选）",
      "cityLabel": "城市或学区",
      "cityPlaceholder": "可选",
      "interestLabel": "我感兴趣的是",
      "interestPlaceholder": "请选择一项",
      "interests": {
        "pilotSchool": "试点学校",
        "demo": "演示 / 参观",
        "general": "一般问题"
      },
      "messageLabel": "留言",
      "messagePlaceholder": "告诉我们您的委员会以及您的需求",
      "marketingConsentLabel": "向我发送 PAC Hub 更新邮件。我可以随时取消订阅。",
      "privacyDisclosureBefore": "提交此表单即表示您同意我们的",
      "privacyPolicyLink": "隐私政策",
      "submitButton": "发送消息",
      "successTitle": "消息已发送",
      "successMessage": "感谢您的联系。我们会尽快回复。",
      "errorMessage": "无法发送您的消息。请稍后再试。"
    },
    "contactValidation": {
      "roleRequired": "请选择您的角色",
      "interestRequired": "请选择一项兴趣",
      "nameRequired": "姓名为必填项",
      "emailInvalid": "必须是有效的电子邮件",
      "messageTooShort": "消息太短",
      "turnstileRequired": "请完成验证"
    },
    "privacy": {
      "title": "隐私政策",
      "lastUpdated": "最后更新：2026 年 6 月",
      "intro": "本政策说明 PAC Hub（「我们」）如何在试点计划之前和期间处理通过 pachub.ca 收集的个人信息。",
      "whoWeAreTitle": "我们是谁",
      "whoWeAreBody": "PAC Hub 为学校家长咨询委员会提供软件。有关隐私问题或请求，请通过 <emailLink>{{email}}</emailLink> 联系我们。",
      "whatWeCollectTitle": "我们收集什么",
      "whatWeCollectIntro": "当您使用我们的联系表单时，我们可能收集：",
      "whatWeCollectItems": {
        "nameEmail": "姓名和电子邮件地址",
        "role": "您的角色（例如家长、委员会执行人员、学校工作人员）",
        "school": "学校名称以及您提供的城市或学区",
        "message": "您的留言和表明的兴趣（例如试点学校）",
        "marketingOptIn": "您是否选择接收有关 PAC Hub 和试点机会的电子邮件更新"
      },
      "turnstileBodyBefore": "我们使用 Cloudflare Turnstile 减少垃圾信息。Cloudflare 可能作为该服务的一部分处理技术数据。请参阅 Cloudflare 的",
      "turnstileLink": "Turnstile 隐私附录",
      "turnstileBodyAfter": "了解他们如何处理这些数据。",
      "whyWeCollectTitle": "我们为何收集",
      "whyWeCollectItems": {
        "respond": "回复您的咨询",
        "followUp": "跟进您询问的试点学校或演示（与咨询相关的联系）",
        "marketing": "仅在您单独勾选营销选项时发送促销邮件"
      },
      "noSelling": "我们不出售家长或委员会联系信息给第三方。",
      "whereStoredTitle": "数据存储位置",
      "whereStoredBody": "当您通过本网站联系我们时，我们将您的提交存储在用于运营 pachub.ca 的安全系统中。访问仅限于需要回复咨询的授权 PAC Hub 团队成员。",
      "retentionTitle": "保留期限",
      "retentionBody": "我们在您的咨询活跃期间及之后合理期限内保留联系记录，或直到您要求我们删除。营销选择加入记录保留至您撤回同意或我们不再需要用于所述目的。",
      "choicesTitle": "您的选择",
      "choicesItems": {
        "access": "您可以通过发送邮件至 <emailLink>{{email}}</emailLink> 请求访问、更正或删除您的信息",
        "unsubscribe": "如果您选择了营销邮件，可随时通过邮件中的取消订阅链接或联系我们取消订阅"
      },
      "changesTitle": "变更",
      "changesBody": "随着营销网站和产品的发展，我们可能会更新本政策。本页顶部的日期显示最后修订时间。",
      "contactLink": "联系我们"
    }
  }
}
